import {Component, Input} from '@angular/core';
import {UntypedFormGroup} from "@angular/forms";
import { NgIf, NgClass } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'cp-password-requirements',
    template: `
    <div *ngIf="form && controlName">
      <!-- header -->
      <div
        class="BasisGrotesqueProBold FontSize_Rem_0_813 LineHeight_Rem_1_25 Password-req-header">
        {{ ('DESIGN_B.USER.PASSWORD_REQUIREMENTS.REQUIREMENTS' | translate) + ':' }}
      </div>
      <!-- container -->
      <div class="Password-req-container">
        <div [ngClass]="{
                'Password-req-item-passed': hasValue() && hasMinLength(),
                'Password-req-item-error': hasValue() && !hasMinLength() && showErrors
             }"
             class="Password-req-item">
          <ng-container>
            <fa-icon *ngIf="hasValue() && hasMinLength(); else noValueOrError"
                     [icon]="['far', 'check']">
            </fa-icon>
          </ng-container>
          <div class="BasisGrotesqueProRegular FontSize_Rem_0_813 LineHeight_Rem_1_25">
            {{ 'DESIGN_B.USER.PASSWORD_REQUIREMENTS.MIN_EIGHT_CHARACTER' | translate }}
          </div>
        </div>
        <div [ngClass]="{
                'Password-req-item-passed': hasValue() && hasUpperAndLoweCase(),
                'Password-req-item-error': hasValue() && !hasUpperAndLoweCase() && showErrors
             }"
             class="Password-req-item">
          <div class="Password-req-item-icon">
            <fa-icon *ngIf="hasValue() && hasUpperAndLoweCase(); else noValueOrError"
                     [icon]="['far', 'check']">
            </fa-icon>
          </div>
          <div class="BasisGrotesqueProRegular FontSize_Rem_0_813 LineHeight_Rem_1_25">
            {{ 'DESIGN_B.USER.PASSWORD_REQUIREMENTS.LOWE_CASE_UPPER_CASE' | translate }}
          </div>
        </div>
        <div [ngClass]="{
                'Password-req-item-passed': hasValue() && hasNumberAndSpecialCharacter(),
                'Password-req-item-error': hasValue() && !hasNumberAndSpecialCharacter() && showErrors
             }"
             class="Password-req-item">
          <ng-container>
            <fa-icon *ngIf="hasValue() && hasNumberAndSpecialCharacter(); else noValueOrError"
                     [icon]="['far', 'check']">
            </fa-icon>
          </ng-container>
          <div class="BasisGrotesqueProRegular FontSize_Rem_0_813 LineHeight_Rem_1_25">
            {{ 'DESIGN_B.USER.PASSWORD_REQUIREMENTS.SPECIAL_CHAR_AND_NUMBER' | translate }}
          </div>
        </div>
      </div>
    </div>

    <ng-template #noValueOrError>
      <div *ngIf="!hasValue() || !showErrors; else error"
           class="Password-req-status_circle">
      </div>
      <ng-template #error>
        <fa-icon [icon]="['fas', 'times']">
        </fa-icon>
      </ng-template>
    </ng-template>
  `,
    styleUrls: ['./password-requirements.component.scss'],
    imports: [NgIf, NgClass, FaIconComponent, TranslateModule]
})
export class PasswordRequirementsComponent {

  //region INPUTS
  /*
   * the form control must have following validators:
   * 1. Validators.minLength(8)
   * 2. Validators.pattern(Constants.PASSWORD_REGEX)
   **/
  @Input()
  form: UntypedFormGroup;
  @Input()
  controlName: string;
  @Input()
  showErrors: boolean = true;
  //endregion

  //region METHODS
  hasValue(): boolean {
    return this.getPassword()?.length > 0;
  }

  hasMinLength(): boolean {
    return !this.form?.get(this.controlName).hasError('minlength');
  }

  hasUpperAndLoweCase(): boolean {
    const regex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])");
    return regex.test(this.getPassword());
  }

  hasNumberAndSpecialCharacter(): boolean {
    const regex = new RegExp("^(?=.*?[#?!@$%&*-])(?=.*\\d)");
    return regex.test(this.getPassword());
  }

  private getPassword(): string {
    return this.form?.get(this.controlName)?.value;
  }
  //endregion
}


